import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import {
  NO_COLOR,
  Palette,
  Picker,
  SelectTrigger,
  ColorPicker as TidalColorPicker
} from "../../../../../components/ColorPicker/index.js";
import { palette as defaultPalette } from "./palette.js";
function ColorPicker(props) {
  const { label, value, palette = defaultPalette, setField, hidePicker = true, hidePalette, allowRandomColor } = props;
  const [open, setOpen] = useState(false);
  const onInvalidColor = (color) => {
    console.error(`ColorPicker - invalid color value: ${color}`);
  };
  const onColorChange = (color) => {
    if (color === NO_COLOR) return;
    setField(label, color);
  };
  return /* @__PURE__ */ jsx(
    TidalColorPicker,
    {
      allowRandomColor,
      localeText: {
        triggerSelectLabel: "Choose color"
      },
      onColorChange,
      onInvalidColor,
      palette: hidePalette ? void 0 : /* @__PURE__ */ jsx(Palette, { palette }),
      picker: hidePicker ? void 0 : /* @__PURE__ */ jsx(Picker, {}),
      testId: "TidalControlsColorPicker",
      trigger: {
        Component: SelectTrigger,
        onSetOpen: setOpen,
        open
      },
      value
    }
  );
}
export {
  ColorPicker
};
//# sourceMappingURL=ColorPicker.js.map
